'use strict'
import getObjectProperty from '../getObjectProperty'
export default (str, data) => {
    try{
        let template = str;
        str.replace(/\${(.*?)}/g, (a, b) => {
            let value = getObjectProperty(data, b);
            if( value !== undefined){
                template = template.replace(a, value);
            }
        });
        return template;
    }catch(err){

    }
}
